import * as Either from "fp-ts/lib/Either";
export var loading = { kind: "Loading" };
export function isLoading(result) {
    return result.kind === "Loading";
}
export var success = function (value) { return ({
    kind: "Success",
    value: value,
}); };
export function isSuccess(result) {
    return result.kind === "Success";
}
export function mapSuccess(mapper) {
    return function (result) {
        if (!isSuccess(result)) {
            return result;
        }
        return success(mapper(result.value));
    };
}
export var fail = function (value) { return ({
    kind: "Fail",
    value: value,
}); };
export function isFail(result) {
    return result.kind === "Fail";
}
export function mapFail(mapper) {
    return function (result) {
        if (!isFail(result))
            return result;
        return fail(mapper(result.value));
    };
}
export function fold(_a) {
    var onLoading = _a.onLoading, onFail = _a.onFail, onSuccess = _a.onSuccess;
    return function (result) {
        switch (result.kind) {
            case "Loading":
                return onLoading();
            case "Fail":
                return onFail(result.value);
            case "Success":
                return onSuccess(result.value);
        }
    };
}
/**
 * @description Apply a transform function on a value only when it is successful.
 * @param mapper the transform function used on the value
 */
export function chainSuccess(mapper) {
    return function (result) {
        return fold({
            onLoading: function () { return loading; },
            onFail: function (error) { return fail(error); },
            onSuccess: function (value) { return mapper(value); },
        })(result);
    };
}
/**
 * @description Create a result from an Either
 */
export function fromEither(either) {
    return Either.fold(function (e) { return fail(e); }, function (v) { return success(v); })(either);
}
